import { ApiSuccessResponse } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import { BrandSearchRequest, BrandSearchResponse } from "./@types";

export const brandApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBrands: builder.mutation<BrandSearchResponse, BrandSearchRequest>({
      query: (requestBody) => ({
        url: "/v1/brands/search",
        method: "POST",
        body: { ...requestBody },
      }),
    }),
    createBrand: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>(
      {
        query: (brandData) => ({
          url: "/v1/brands",
          method: "POST",
          body: { ...brandData },
        }),
      },
    ),
    updateBrand: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>(
      {
        query: (brandData) => ({
          url: `/v1/brands/${brandData.id}`,
          method: "PUT",
          body: { ...brandData },
        }),
      },
    ),
    deleteBrand: builder.mutation<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/v1/brands/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetBrandsMutation,
  useCreateBrandMutation,
  useUpdateBrandMutation,
  useDeleteBrandMutation,
} = brandApiSlice;
